module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "tit"
  }, [_c('b', [_c('i', [_vm._v("Memphis")])])]), _vm._v(" "), _c('p', {
    staticClass: "tit1"
  }, [_c('b', [_c('i', [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LUES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tit2"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRTHPLACE OF A")]), _c('br'), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USIC")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RADITION")])]), _vm._v(" "), _c('p', {
    staticClass: "tit3"
  }, [_vm._v("William Bearden")]), _vm._v(" "), _c('p', {
    staticClass: "tit3"
  }, [_vm._v("Foreword by Knox Phillips")]), _vm._v(" "), _c('p', {
    staticClass: "tit4"
  }, [_c('img', {
    staticClass: "c1",
    attrs: {
      "alt": "Images",
      "src": "Images/logo.gif"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55af9e88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/title.vue
// module id = 57
// module chunks = 0